import Modal from "@mui/material/Modal";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  Box,
  CircularProgress,
  Typography,
  IconButton,
  Stack,
} from "@mui/material";
import type { RootState } from "../../../../..//store/Index";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import apiService from "../../../../../service/Api";
import { useParams } from "react-router-dom";

interface SyncCommentsModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

type syncingStatusType = "initial" | "syncing" | "synced" | "failed";

export const SyncCommentsModal: React.FC<SyncCommentsModalProps> = ({
  open,
  setOpen,
}) => {
  const { id } = useParams<{ id: string }>();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const [syncingStatus, setSyncingStatus] =
    useState<syncingStatusType>("initial");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    if (!open) {
      return;
    }
    syncComments();
  }, [open]);

  const syncComments = async () => {
    setSyncingStatus("syncing");

    try {
      const response = await apiService.get<any>(
        `/api/streams/stream/${id}/fetch-youtube-comments/`
      );
      console.log(response);
      setSyncingStatus("synced");
    } catch (error: any) {
      const errMsg = error.response.data.detail;
      setErrorMessage(errMsg || "Failed to sync comments");
      setSyncingStatus("failed");
    }
  };

  return (
    <Modal
      open={open}
      //onClose={() => setOpen(false)}
      aria-labelledby="syncing-comments-modal"
      aria-describedby="syncing-comments-modal-description"
    >
      <Box
        sx={{
          borderRadius: 1,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "background.paper",
          boxShadow: 24,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            padding: "0 .5em",
            borderBottom: `1px solid whitesmoke`,
          }}
        >
          <IconButton sx={{ "&:hover": { color: "#a60b0bff" } }}>
            <CloseIcon onClick={() => setOpen(false)} />
          </IconButton>
        </Box>

        {syncingStatus === "syncing" && (
          <Stack sx={{ padding: "2em 0" }}>
            <Box sx={{ width: "fit-content", marginInline: "auto" }}>
              <CircularProgress size={30} />
            </Box>
            <Typography variant="body2" sx={{ textAlign: "center", mt: 2 }}>
              Syncing comments
            </Typography>
          </Stack>
        )}

        {syncingStatus === "synced" && (
          <Stack sx={{ padding: "2em 0" }}>
            <Box sx={{ width: "fit-content", marginInline: "auto" }}>
              <TaskAltIcon sx={{ width: 50, height: 50, color: "#048b3dff" }} />
            </Box>
            <Typography variant="body2" sx={{ textAlign: "center", mt: 2 }}>
              100 Comments Synced
            </Typography>
          </Stack>
        )}

        {syncingStatus === "failed" && (
          <Stack sx={{ padding: "2em 0" }}>
            <Box sx={{ width: "fit-content", marginInline: "auto" }}>
              <ErrorOutlineIcon
                sx={{ width: 50, height: 50, color: "#a60b0bff" }}
              />
            </Box>
            <Typography variant="body2" sx={{ textAlign: "center", mt: 2 }}>
              {errorMessage}
            </Typography>
          </Stack>
        )}
      </Box>
    </Modal>
  );
};
